import { FIELD_VALUES } from '@funnels/constants';

export const getHeadingTypeBinary = (
  customerRole: FIELD_VALUES.BORROWER | FIELD_VALUES.GUARANTOR,
  targetApplicantRole: FIELD_VALUES.BORROWER | FIELD_VALUES.GUARANTOR,
  onlyOneItem: boolean
): string =>
  `${
    customerRole === FIELD_VALUES.BORROWER ? FIELD_VALUES.BORROWER.toLowerCase() : FIELD_VALUES.GUARANTOR.toLowerCase()
  }-viewing-${onlyOneItem ? FIELD_VALUES.SINGLE.toLowerCase() : FIELD_VALUES.MULTIPLE.toLowerCase()}-${
    targetApplicantRole === FIELD_VALUES.BORROWER
      ? FIELD_VALUES.BORROWER.toLowerCase()
      : FIELD_VALUES.GUARANTOR.toLowerCase()
  }`;
